import type { GAmoduleConfig } from '@maestro/google-analytics/types'

export function getGoogleAnalyticsConfig(): GAmoduleConfig {
  const isEnabled = process.env.NEXT_PUBLIC_GA_ENABLED === 'true'
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID
  const gtmUrlParams = process.env.NEXT_PUBLIC_GTM_URL_PARAMS ?? ''
  const isDebug = process.env.NEXT_PUBLIC_GA_DEBUG === 'true'
  const preconnectUrls =
    isEnabled && gtmId ? [`https://www.googletagmanager.com`] : []

  if (!isEnabled) {
    return {
      isEnabled: false,
      gtmId: '',
      gtmUrlParams: '',
      isDebug,
      preconnectUrls,
    }
  }

  if (!gtmId) {
    throw new Error(
      'Missing required Google Analytics configuration. Please set NEXT_PUBLIC_GTM_ID environment variable.'
    )
  }

  return {
    isEnabled,
    gtmId,
    gtmUrlParams,
    isDebug,
    preconnectUrls,
  }
}
